module.exports = __webpack_public_path__ + "static/media/truck-container.25ab9c5e.svg";